import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { retrieveContentfulImage } from '../../common/image.js';
import clsx from 'clsx';
import { useTheme, Container, Grid, Box, Typography } from '@material-ui/core';
import PropTypes__default from 'prop-types';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      width: "100%",
      zIndex: -2,
      maxWidth: "100%"
    },
    titleBox: _defineProperty({
      background: "rgba(145, 138, 126, 0.75)",
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      padding: theme.spacing(5, 2)
    }, theme.breakpoints.up("md"), {
      maxWidth: "680px",
      marginTop: theme.spacing(30),
      padding: theme.spacing(5)
    }),
    titleText: {
      marginBottom: theme.spacing(3)
    },
    heading: _defineProperty({
      lineHeight: "127%",
      color: theme.palette.text.white
    }, theme.breakpoints.up("md"), {
      color: theme.palette.text.white
    }),
    infoMessage: _objectSpread(_objectSpread({}, theme.typography.infoMessage), {}, {
      color: theme.palette.text.white
    }),
    arrow: {
      position: "absolute",
      color: "#FFFFFF",
      bottom: 0,
      left: "50%",
      mixBlendMode: "normal",
      transform: "translate(-50%)",
      fontSize: theme.spacing(6),
      filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))"
    },
    imageWrapper: {
      position: "relative",
      margin: "0 auto"
    },
    maxWidth1150: {
      maxWidth: "1150px"
    },
    pl3: _defineProperty({
      paddingLeft: theme.spacing(3)
    }, theme.breakpoints.down("md"), {
      paddingLeft: theme.spacing(0)
    })
  };
});
var ImageHero = function ImageHero(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    imageUrl = _ref.imageUrl;
  var classes = useStyles();
  var theme = useTheme();
  var _window = window,
    width = _window.innerWidth;
  var styles = {
    width: "100vw",
    height: theme.spacing(83.75)
  };
  var bgImageOptions = {
    sizeOptions: {
      width: width,
      height: styles.height,
      fit: "fill"
    }
  };
  if (imageUrl) {
    styles = _objectSpread(_objectSpread({}, styles), {}, {
      backgroundImage: "url(".concat(retrieveContentfulImage(imageUrl, bgImageOptions.sizeOptions), ")"),
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat"
    });
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Container, {
    disableGutters: true,
    className: classes.root
  }, imageUrl && /*#__PURE__*/React__default.createElement("div", {
    style: styles,
    className: classes.imageWrapper
  }, /*#__PURE__*/React__default.createElement(Container, {
    maxWidth: "lg"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justify: "flex-start",
    className: clsx(classes.maxWidth1150, classes.pl3)
  }, /*#__PURE__*/React__default.createElement(Box, {
    className: classes.titleBox
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    sm: 12
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h1",
    className: clsx(classes.heading, classes.titleText)
  }, title), /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.infoMessage
  }, subtitle))))), /*#__PURE__*/React__default.createElement(ExpandMoreIcon, {
    className: classes.arrow
  }))));
};
ImageHero.propTypes = {
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string
};

export { ImageHero as default };
//# sourceMappingURL=ImageHero.js.map
